export default __webpack_public_path__ + "static/media/paper.3c8b7504.svg";